import React from 'react';

export function RouteIcon({ name, size = 16, ...props }) {
    const paths = {
        search: <><circle cx="10.5" cy="10.5" r="6" /><path d="m15 15 4.5 4.5" /></>,
        plus: <path d="M12 5v14M5 12h14" />,
        pin: <><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
        edit: <><path d="m14.5 5.5 4 4M4 20l4.5-1 12-12a1.4 1.4 0 0 0 0-2l-1-1a1.4 1.4 0 0 0-2 0l-12 12L4 20Z" /></>,
        up: <path d="M12 19V5m-5 5 5-5 5 5" />,
        down: <path d="M12 5v14m-5-5 5 5 5-5" />,
        left: <path d="m14 6-6 6 6 6" />,
        right: <path d="m10 6 6 6-6 6" />,
        warning: <><path d="m10.4 4.5-8 14a1.8 1.8 0 0 0 1.6 2.7h16a1.8 1.8 0 0 0 1.6-2.7l-8-14a1.8 1.8 0 0 0-3.2 0Z" /><path d="M12 9v5m0 3v.2" /></>,
    };
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name]}</svg>;
}
export const searchKey = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
export const routeInitials = name => (String(name).match(/[\p{L}\p{N}]+/gu) || []).slice(0, 2).map(word => word[0]).join('').toUpperCase();
export function StatusBadge({ active, route = false }) {
    return <span className={`rc-status ${active ? 'rc-status--active' : 'rc-status--inactive'}`}><span aria-hidden="true" className="rc-status-dot" />{route ? (active ? 'Ruta activa' : 'Ruta inactiva') : (active ? 'Activa' : 'Inactiva')}</span>;
}
export function RoutePagination({ page, pages, onChange, label }) {
    let numbers;
    if (pages <= 4) numbers = Array.from({ length: pages }, (_, i) => i + 1);
    else if (page <= 2) numbers = [1, 2, 3, '…', pages];
    else if (page >= pages - 1) numbers = [1, '…', pages - 2, pages - 1, pages];
    else numbers = [1, '…', page, '…', pages];
    return <nav className="rc-pagination" aria-label={label}>
        <button type="button" className="rc-page-button" aria-label="Página anterior" disabled={page === 1} onClick={() => onChange(page - 1)}><RouteIcon name="left" size={14} /></button>
        {numbers.map((number, i) => typeof number === 'number' ? <button key={number} type="button" className={`rc-page-button ${page === number ? 'is-current' : ''}`} aria-label={`Página ${number}`} aria-current={page === number ? 'page' : undefined} onClick={() => onChange(number)}>{number}</button> : <span key={`gap-${i}`} className="rc-page-gap">{number}</span>)}
        <button type="button" className="rc-page-button" aria-label="Página siguiente" disabled={page === pages} onClick={() => onChange(page + 1)}><RouteIcon name="right" size={14} /></button>
    </nav>;
}
export function locationAddress(address) {
    const parts = String(address || '').split(',').map(part => part.trim()).filter(Boolean);
    if (parts.length > 2 && /^[A-Z]{2}$/.test(parts[parts.length - 1]) && /^[A-Z]{2}-[\w]+$/.test(parts[parts.length - 2])) parts.pop();
    if (parts.length > 2 && /^[A-Z]{2}-[\w]+$/.test(parts[parts.length - 1])) {
        const state = parts.pop(), city = parts.pop();
        return { street: parts.join(', '), region: `${city} · ${state}` };
    }
    return { street: address || 'Sin dirección registrada', region: '' };
}
